import(/* webpackMode: "eager" */ "/vercel/path0/src/app/services/special-events/page.js")